import { useContext, useCallback } from "react";
import { UserContext } from "../contexts/UserContext";
import { WiMuleSQL } from "../services/WiMuleSQL";

export const useFetchUserDetails = () => {
  const { setUserDetails } = useContext(UserContext);

  const fetchDetails = useCallback(
    async (email) => {
      try {
        const response = await fetch(
          `${WiMuleSQL}/api/Auth/GetUserAccountData?email=${email}`
        );
        if (!response.ok) {
          throw new Error(
            `useFetchUserDetails - HTTP Error: ${response.status}`
          );
        }
        const data = await response.json();
        if (data && data.data) {
          console.log("🔹 Fetching user details:", data.data);

          setUserDetails((prev) => ({
            ...prev,
            userId: data.data.id ?? prev.userId,
            userEmail: data.data.email ?? prev.userEmail,
            userName: data.data.userName ?? prev.userName,
            userCompany: data.data.company ?? prev.userCompany,
            userImage: data.data.userImageBase64 || prev.userImage, // ✅ Preserve previous image if no new one is provided
            userWiMuleToken: prev.userWiMuleToken, // ✅ Preserve WiMuleToken
            userWiMuleTokenTimestamp: prev.userWiMuleTokenTimestamp, // ✅ Preserve WiMuleToken timestamp
          }));

          console.log("✅ Updated userDetails:", data.data);
        }
      } catch (error) {
        console.error(
          "useFetchUserDetails - Failed to fetch user details:",
          error
        );
      }
    },
    [setUserDetails]
  );

  return fetchDetails;
};
